import { IDropDownOption, OptionItem, PropInfo, Section, SectionFactory, TextBoxOption } from '../sections/TextSection'
import { EVENTS } from '../../store/EventEmitter'
import { changeType, StateManager } from '../../store/StateManager'
import { DomHelper } from '../../utlis/DomHelper'
import { FileField } from './fields/FileField'
import { Field } from './fields/Field'
import { NumberField } from './fields/NumberField'
import { DecimalField } from './fields/DecimalField'
import { TextField } from './fields/TextField'
import { ColorPickerField } from './fields/ColorPickerField'
import { GradientColorPickerField } from './fields/GradientColorPickerField'
import { DropDownField } from './fields/DropdownFiled'
import { TagField } from './fields/TagField'
import { LayoutManager } from '../../LayoutManager'
import { TextBoxesField } from './fields/TextBoxesField'
import { CSS_CLASSES, SELECTORS } from '../../constants/CSSClasses'
import { AudioField } from './fields/AudioField'
import { IStateChangeInfo } from '../../managers/UndoManager'
import { ILayoutBuilderOptions, IMediaDeliveryConfig } from '../../types'
import "./propertyPanel.css"
import { pageLevelDefaultProps } from '../../sampleConfig'

export class PropertyManager {
  private propertyPanel: HTMLElement
  private $state: StateManager = StateManager.getInstance()
  private propertyFields: Field[]
  private boundStateUpdate: (args: IStateChangeInfo) => void
  private mediaConfig: IMediaDeliveryConfig
  constructor(parentElement: HTMLElement, mediaConfig: IMediaDeliveryConfig) {
    this.mediaConfig = mediaConfig;
    this.propertyPanel = parentElement
    this.propertyFields = []
    this.boundStateUpdate = this.handleStateUpdate.bind(this)
    this.createStructure()
    this.$state.subscribe(EVENTS.STATE_UPDATED, this.boundStateUpdate)
    this.renderPageProperties()
  }

  private createStructure(): void {
    this.propertyPanel.innerHTML = `
      <div class="${CSS_CLASSES.PAGE_PROPERTY_Container}">
        <h3>Page Properties</h3>
      </div>
      <div class="${CSS_CLASSES.PROPERTY_PANEL_CONTAINER}">
      </div>
      `
  }
  private renderPageProperties(): void {
    if(this.propertyPanel.querySelector(`.${CSS_CLASSES.PAGE_PROPERTY_Container}`) === null) {
      this.createStructure();
    };
    const pagePropEl = this.propertyPanel.querySelector(`.${CSS_CLASSES.PAGE_PROPERTY_Container}`) as HTMLDivElement;
    pagePropEl.innerHTML = '';
    pagePropEl.style.display = "none";
    const state = this.$state.getState()
    state.propInfo?.forEach((propInfo: PropInfo) => {
      let field = this.createPageLevelField(propInfo);
      pagePropEl?.appendChild(field!.render());
    })



  }
  private handleStateUpdate(args:IStateChangeInfo): void {
    if(args.changeType === changeType.UPDATE_PAGE_PROP || args.changeType === changeType.UPDATE_ALL_Section){
      //need to render Page level properties
      this.renderPageProperties();  

    }

    this.propertyFields.forEach(field => {
      field.destroy()
    });
    const selectedContainers = this.$state.getSelectedSections();

    this.propertyFields = [];
    if (selectedContainers.length === 1) {
      this.setSelectedContainer(selectedContainers[0])
    } else if (selectedContainers.length > 1) {
      this.setMultipleSelection(selectedContainers)
    } else {
      this.clearPropertyPanel()
    }
  }

  private clearPropertyPanel(): void {
    const panelContainer = this.propertyPanel.querySelector(`.${CSS_CLASSES.PROPERTY_PANEL_CONTAINER}`)
    if (!panelContainer) return
    this.propertyFields.forEach(field => {
      field.destroy()
    });
    // Remove event listeners from buttons
    panelContainer.querySelectorAll('button').forEach(button => {
      const handler = button.dataset.boundHandler
      if (handler) {
        const boundHandler = window[handler as keyof typeof window]
        if (typeof boundHandler === 'function') {
          button.removeEventListener('click', boundHandler)
        }
      }
    })
    
    panelContainer.innerHTML = ''
  }

  private setMultipleSelection(containers: Section[]): void {
    this.propertyPanel.querySelector(`.${CSS_CLASSES.PROPERTY_PANEL_CONTAINER}`)!.innerHTML = `
      <div class="property-panel-container">
        <h3>Multiple Selection</h3>
        <p>${containers.length} items selected</p>
      </div>
    `    
  }

  public setSelectedContainer(container: Section): void {
    this.renderContainerHeader(container)    
    this.renderSubmitButton(container)
    this.renderFields(container)
  }

  private renderContainerHeader(container: Section): void {
    (this.propertyPanel.querySelector('.'+CSS_CLASSES.PROPERTY_PANEL_CONTAINER) as HTMLDivElement).innerHTML = `
      <div class="property-panel-container">
        <h3>${container.name}</h3>
      </div>
    ` 
  }

  private renderFields(container: Section): void {
    // const fields = ['row', 'col', 'rowCount', 'colCount']
    // fields.forEach((field) => {
    //   const fieldInstance = new NumberField(field, (container as any)[field], () => {})
    //   this.propertyPanel.querySelector('.property-panel-container')?.appendChild(fieldInstance.render())
    // })
    //this.addBringToFrontAndSendToBack(container);
    container.propInfo?.forEach((propInfo: PropInfo) => {
      if(propInfo.inputType =='none') return;
      const fieldInstance = this.createFieldInstance(propInfo,container)
      this.propertyFields.push(fieldInstance!)
      this.propertyPanel.querySelector('.property-panel-container')?.appendChild(fieldInstance!.render())
    })
  }

  private renderSubmitButton(container: Section): void {
    const submitButton = document.createElement('button')
    submitButton.textContent = 'Submit'
    const boundSubmitHandler = () => this.handleSubmit(container)
    submitButton.addEventListener('click', boundSubmitHandler)
    // Store the handler reference for cleanup
    submitButton.dataset.boundHandler = String(boundSubmitHandler)
    this.propertyPanel.querySelector('.property-panel-container')?.appendChild(submitButton)
  }

  private handleSubmit(container: Section): void {
    const state = this.$state.getState()
    this.updateContainerFields(container, state)
    this.updateContainerPropInfo(container, state)
    this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.UPDATE_SECTION })
    this.syncStateWithDiv()
  }

  private addBringToFrontAndSendToBack(container: Section): void {
    const bringTofront = document.createElement('button')
    const sendToBack = document.createElement('button')
    bringTofront.textContent = 'Bring To Front'
    sendToBack.textContent = 'Send To Back'
    
    const boundBringToFront = () => {
      const state = this.$state.getState()
      const section = state.sections.find((x: Section) => x.id === container.id)
      const index = state.sections.indexOf(section as Section)
      state.sections.splice(index, 1)
      state.sections.push(section as Section)
      this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.BRING_TO_FRONT })
      LayoutManager.bringToFront(container.id)
    }

    const boundSendToBack = () => {
      const state = this.$state.getState()
      const section = state.sections.find((x: Section) => x.id === container.id)
      const index = state.sections.indexOf(section as Section)
      state.sections.splice(index, 1)
      state.sections.unshift(section as Section)
      this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.SEND_TO_BACK })
      LayoutManager.sendToBack(container.id)
    }

    bringTofront.addEventListener('click', boundBringToFront)
    sendToBack.addEventListener('click', boundSendToBack)

    // Store handler references for cleanup
    bringTofront.dataset.boundHandler = String(boundBringToFront)
    sendToBack.dataset.boundHandler = String(boundSendToBack)

    const propertyContainer = this.propertyPanel.querySelector('.property-panel-container')
    if (propertyContainer) {
      propertyContainer.appendChild(bringTofront)
      propertyContainer.appendChild(sendToBack)
    }
  }

  private updateContainerFields(container: Section, state: any): void {
    const fields = ['row', 'col', 'rowCount', 'colCount']
    fields.forEach((field) => {
      const input = this.propertyPanel.querySelector(`input[name="${field}"]`) as HTMLInputElement
      if (input) {
        const newValue = input.value;
        (container as any)[field] = Number(newValue) || newValue
        state.sections.forEach((s:Section) => {
          if (s.id === container.id) {
            (s as any)[field] = Number(newValue) || newValue
          }
        })
      }
    })
  }

  private updateContainerPropInfo(container: Section, state: any): void {
    container.propInfo?.forEach((propInfo: PropInfo) => {
      const input = this.getInputEl(propInfo) as HTMLInputElement
      if (input) {
        const newValue = (input as any)['fieldObj']?.value || input.value
        propInfo.value = newValue
        state.sections.forEach((s:Section) => {
          if (s.id === container.id) {
            const stateProp = s.propInfo?.find((x:PropInfo) => x.name === propInfo.name)
            if (stateProp) {
              stateProp.value = stateProp.inputType === 'number' ? newValue + 'px' : newValue
            }
          }
        })
      }
    })
  }

  private getInputEl(prop: PropInfo): HTMLInputElement | HTMLSelectElement | null {
    return this.propertyPanel.querySelector(
      prop.inputType === 'dropdown' ? `select[name="${prop.name}"]` : `input[name="${prop.name}"]`
    )
  }

  private createFieldInstance(prop: PropInfo,container:Section): Field | undefined {
    const value = prop.inputType === 'number' ? parseInt(prop.value) : prop.value
    switch (prop.inputType) {
      case 'text':
        return new TextField(prop.name, value, () => {})
      case 'number':
        return new NumberField(prop.name, value, (value) => {
          value = prop.inputType === 'number' ? value + 'px' : value
          container.propInfo?.forEach((p:PropInfo) => {
            if(p.name === prop.name){
              p.value = value;
            }
          });
          const state = this.$state.getState();
          state.sections.forEach((s:Section) => {
            if (s.id === container.id) {
              const stateProp = s.propInfo?.find((x:PropInfo) => x.name === prop.name)
              if (stateProp) {
                stateProp.value = value
              }
            }
          });
          const dragDiv = DomHelper.getSectionDiv(container.id) as HTMLDivElement;
          let sectionDiv = document.querySelector(`.layout-drag-item[id="${container.id}"] .section`) as HTMLDivElement;
          (dragDiv as any)['sectionObj'].propInfo = container.propInfo?.map(x=>x);
          DomHelper.setBindingValue(sectionDiv, prop.binding, value);
          this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.UPDATE_SECTION });

        })
      case 'decimal':
        let step=0.1;
        let min=0;
        let max=100;
        if(prop.name =='opacity'){
          max = 1;
        }
        return new DecimalField(prop.name, value,min,max,step, () => {})
      case 'color':
        return new ColorPickerField(prop.name, value, () => {})
        
      case 'gradientcolor':
        return new GradientColorPickerField(prop.name, value, (val) => {
          console.log(val);
          prop.value = val;
          const state = this.$state.getState();
          state.sections.forEach((s:Section) => {

            if (s.id === container.id) {
              const stateProp = s.propInfo?.find((x:PropInfo) => x.name === prop.name)
              if (stateProp) {
                stateProp.value = val
              }
            }
          });
          const dragDiv = DomHelper.getSectionDiv(container.id) as HTMLDivElement;
          let sectionDiv = document.querySelector(`.layout-drag-item[id="${container.id}"] .section`) as HTMLDivElement;
          (dragDiv as any)['sectionObj'].propInfo = container.propInfo?.map(x=>x);
          DomHelper.setBindingValue(sectionDiv, prop.binding, val);
          this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.UPDATE_SECTION });

        })
      case 'file':
        return new FileField(prop.name,value, this.mediaConfig, (value) => {
          let state = this.$state.getState();
          //update the propInfo value for the contianer
          container.propInfo?.forEach((p:PropInfo) => {
            if(p.name === prop.name){
              p.value = value;
            }
          });
          state.sections.forEach((s:Section) => {
            if (s.id === container.id) {
              const stateProp = s.propInfo?.find((x:PropInfo) => x.name === prop.name)
              if (stateProp) {
                stateProp.value = value
              }
            }
          });
          this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.UPDATE_SECTION });
          const dragDiv = DomHelper.getSectionDiv(container.id) as HTMLDivElement;
          let sectionDiv = document.querySelector(`.layout-drag-item[id="${container.id}"] .section`) as HTMLDivElement;
          (dragDiv as any)['sectionObj'].propInfo = container.propInfo?.map(x=>x); 
          DomHelper.setBindingValue(sectionDiv, prop.binding, value);
        })
      case 'dropdown':
        return new DropDownField(prop.name, value, (prop.options as IDropDownOption[]), () => {})
      case 'multiOptionTextBox':
        return new TextBoxesField(prop.name, container.options as TextBoxOption[], (values) => {
          this.updateOptionField(values,container);
        })
      case 'tags':
        return new TagField(prop.name, container.options as OptionItem[], (tags) => {
          console.log(tags);
          this.updateOptionField(tags,container);
        })
       case 'audio':
        return new AudioField(prop.name, value, this.mediaConfig, (val) => {
          prop.value = val;
          const state = this.$state.getState();
          state.sections.forEach((s:Section) => {
            if (s.id === container.id) {
              const stateProp = s.propInfo?.find((x:PropInfo) => x.name === prop.name)
              if (stateProp) {
                stateProp.value = val;
              }
            }
          });
          const dragDiv = DomHelper.getSectionDiv(container.id) as HTMLDivElement;
          let sectionDiv = document.querySelector(`.layout-drag-item[id="${container.id}"] .section`) as HTMLDivElement;
          (dragDiv as any)['sectionObj'].propInfo = container.propInfo?.map(x=>x);
          DomHelper.setBindingValue(sectionDiv, prop.binding, val);
          this.$state.setState({ sectionIds: [container.id], state: state, changeType: changeType.UPDATE_SECTION });
        });
      default:
    }
  }

  private createPageLevelField(prop: PropInfo): Field | undefined {
    const value = prop.inputType === 'number' ? parseInt(prop.value) : prop.value
    switch (prop.inputType.toLocaleLowerCase()) {
      case 'audio':
        return new AudioField(prop.name, value,this.mediaConfig, (value) => {
          let oldState = this.$state.getState();
          let newProp:PropInfo = pageLevelDefaultProps.find(x=>x.inputType='audio') as PropInfo;
          newProp!.value = value;
          oldState.propInfo.addOrReplace(item=>{
            return item.name == newProp?.name;
          },newProp);

          this.$state.setState({
            sectionIds:[],
            state:{...oldState,sections: oldState.sections,propInfo:[...oldState.propInfo]},
            changeType:changeType.UPDATE_PAGE_PROP
          }
        );
        })
      default:
    }

  }


  private updateOptionField(options:TextBoxOption[] | OptionItem[], container:Section): void {
    console.log(options);
    let oldState = this.$state.getState();

    let newSections = oldState.sections.map(s=>{
      if(s.id===container.id){
        s.options = options;
      }
      return s;
    });
    (container as any).options = [...options];
    this.$state.setState({
      sectionIds:[container.id],
      state:{...oldState,sections:[...newSections]},
      changeType:changeType.UPDATE_SECTION
    })
    
    LayoutManager.syncSectionToDom(container);
  }
  private syncStateWithDiv(): void {
    const state = this.$state.getState()
    const scale = (state.scale)?state.scale:[1,1]
    const zoomValue = this.$state.getZoomValue()
    state.sections.forEach((container) => {
      var sectionDiv = document.querySelector(`.layout-drag-item[id="${container.id}"] .section`) as HTMLDivElement
      const dragDiv = document.querySelector(`.layout-drag-item[id="${container.id}"]`) as HTMLDivElement
      const sectionObj = (dragDiv as any)['sectionObj'];
      if (dragDiv) {
        dragDiv.style.height = `${container.rowCount * state.cellHeight}px`
        dragDiv.style.width = `${container.colCount * state.cellWidth}px`
        dragDiv.style.left = `${container.col * state.cellWidth * zoomValue * scale[0]}px`
        dragDiv.style.top = `${container.row * state.cellHeight * zoomValue * scale[1]}px`

        if(container.type === 'line' || container.type === 'arrow'){
          let ob = SectionFactory.getSectionByType(container);
          dragDiv.replaceChild(ob!.render(), dragDiv.firstChild!);
          
        }
        sectionDiv = document.querySelector(`.layout-drag-item[id="${container.id}"] .section`) as HTMLDivElement
        
        container.propInfo?.forEach((propInfo) => {
          DomHelper.setBindingValue(sectionDiv, propInfo.binding, propInfo.value)});
          
          (dragDiv as any)['sectionObj'] = container; 
        // LayoutManager.syncSectionToDom(container);
      }
    })  
  }

  public destroy(): void {
    // Cleanup state subscription
    this.$state.unsubscribe(EVENTS.STATE_UPDATED, this.boundStateUpdate)
    
    // Destroy all field instances
    this.propertyFields.forEach(field => {
      if (field && typeof field.destroy === 'function') {
        field.destroy()
      }
    })
    this.propertyFields = []

    // Clear property panel
    this.clearPropertyPanel()
    
    // Remove references
    this.propertyPanel.innerHTML = ''
    this.propertyPanel = null as any
    this.$state = null as any
    this.boundStateUpdate = null as any
  }

  addOrReplace(){

  }

}
